import { ChangeDetectionStrategy, Component, ViewChild, output, input, effect, signal } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { RouterModule } from '@angular/router';
import { SpeedDialModule } from 'primeng/speeddial';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule, Table } from 'primeng/table';
import { FilterMatchMode } from 'primeng/api';
import { OnActionEvent } from '../../models/pagination.abstract';

import { GetPathPipe } from '../../pipes/loadash-get.pipe';
import { MenuItem } from 'primeng/api';

export interface PColumn {
  field: string;
  header: string;
  type?: 'text' | 'image';
}

@Component({
  selector: 'app-quick-table',
  imports: [CardModule, ButtonModule, SpeedDialModule, PaginatorModule, TableModule, RouterModule, GetPathPipe, InputTextModule],
  templateUrl: './quick-table.html',
  styleUrl: './quick-table.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class QuickTableComponent {
  // Inputs
  readonly columns = input<PColumn[]>([]);
  readonly tableData = input<any[]>([]);
  // Default action is only select
  readonly actions = input<MenuItem[]>([{ title: 'select', label: 'Select', icon: 'pi pi-check', severity: 'primary' }]);

  // Outputs
  readonly onAction = output<OnActionEvent>();

  // Signals
  public _columns = signal<PColumn[]>([]);
  public filters = signal<Record<string, any>>({});
  public globalFilterFields = signal<string[]>([]);

  @ViewChild('dataTable') table!: Table;

  tableColumns: any[] = [];

  constructor() {
    // super();
    effect(() => {
      this.initializeTableColumns();
      this.initializeFilters();
    });
  }

  private initializeTableColumns(): void {
    console.log('tableData', this.columns());
    if (!this.columns() || this.columns().length === 0) {
      console.warn('No columns provided. please privide columns for acuracy');
      if (this.tableData()[0]) {
        this.tableColumns = Object.keys(this.tableData()[0]).map((key) => ({
          field: key,
          header: key,
          sortable: true,
        }));
        console.log(this.tableColumns);
        this._columns.set(this.tableColumns);
      }
    } else {
      // Transform string column names to column objects
      this.tableColumns = this.columns().map((col) => ({
        field: col,
        header: col,
        sortable: true,
      }));

      // Add actions column
      this.tableColumns.push({
        field: 'actions',
        header: 'Actions',
      });
      this._columns.set(this.tableColumns);
    }
  }

  // private configureTable(): void {
  //   // Configure table properties programmatically if needed
  //   this.table.reset();
  //   this.table.rows = 5;
  //   this.table.paginator = true;
  //   this.table.rowsPerPageOptions = [5, 10, 20];
  //   this.table.tableStyle = { 'min-width': '50rem' };
  //   this.cdr.detectChanges();
  // }

  public selectItem(item: any, action: MenuItem) {
    console.log('onAction', { item, action });
    this.onAction.emit({ item, action: action.label });
  }

  public onGlobalFilter(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.table.filterGlobal(value, FilterMatchMode.CONTAINS);
  }

  public getFilterType(column: PColumn): string {
    if (column.type === 'image') {
      return 'text';
    }
    return 'text';
  }

  private initializeFilters(): void {
    // Initialize filters
    const filterObj: Record<string, any> = {};
    const fields: string[] = [];

    if (this._columns()) {
      this._columns().forEach((col) => {
        if (col.field !== 'actions') {
          // Add field to global filter fields
          fields.push(col.field);

          // Initialize filter for this column
          filterObj[col.field] = {
            value: null,
            matchMode: FilterMatchMode.CONTAINS,
          };
        }
      });
    }

    this.filters.set(filterObj);
    this.globalFilterFields.set(fields);
  }

  // private getActionTemplate(item: any): any {
  //
  //   if (!this.onlyView()) {
  //     return {
  //       edit: () => this.selectItem(item, { title: 'edit', label: 'Edit', icon: 'pi pi-pencil', severity: 'primary' }),
  //       delete: () => this.selectItem(item, { title: 'delete', label: 'Delete', icon: 'pi pi-trash', severity: 'danger' }),
  //       view: () => this.selectItem(item, { title: 'view', label: 'View', icon: 'pi pi-eye', severity: 'info' }),
  //     };
  //   } else {
  //     return {
  //       select: () => this.selectItem(item, { title: 'select', label: 'Select', icon: 'pi pi-check', severity: 'primary' }),
  //     };
  //   }
  // }
}
